import Head from "next/head";
import FeaturedProject from "../../components/Lists/FeaturedProject";
import ProjectList from "../../components/Lists/ProjectList";
import {redirectTo500} from "../../utils/utility";
import ghost from "../../utils/ghost";

export async function getStaticProps(context) {
    const featuredData = await ghost({
        filter: "tags:project" + "+featured:true",
        pagination:{limit:3}
    });
    const listPagedData = await ghost({
        filter: "tags:project" + "+featured:false",
        pagination:{limit:"all"}
    });

    if (!featuredData || !listPagedData) {
        return redirectTo500();
    }
    return {
        props: {
            featured: featuredData,
            listData: listPagedData,
        },
        revalidate: 3600,
    };
}

const Projects = props => {
    return (
        <>
            <Head>
                <title>Projects | Best Offshore Software Outsourcing</title>
                <meta
                    name="description"
                    content="More than 20 years of experience in developing large-scale enterprise software solutions both locally and globally. Extensive experience in developing complex e-Service solutions for the government of Bangladesh with nationwide implementation."
                />
            </Head>
            <div className="bg-white w-full pt-6 md:pt-16">
                <div className="grid mid-home-column items-center">
                    <h2 className="text-black font-headline items-center break-words text-center font-normal text-4xl md:text-6xl">
                        Our Projects
                    </h2>
                </div>
            </div>

            {/* featured */}
            <div className="bg-white w-full py-9 md:py-20">
                <div className="grid mid-home-column">
                    <div className="pb-9 md:pb-12 items-center flex flex-col mx-5">
                        <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
                            Featured
                        </h2>
                        <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
                            Our top projects in terms of scale, complexity, and impact
                        </p>
                    </div>
                    <div className="flex mx-5">
                        <FeaturedProject
                            how={props.featured.posts}
                            path="/projects/"
                            title="GO TO PROJECT"
                        />
                    </div>
                </div>
            </div>

            {/* list */}
            <div className="w-full pb-9 md:pt-8 md:pb-28 flex">
                <div className="grid mid-home-column mid-column">
                    <div className="pb-12 items-center flex flex-col mx-5">
                        <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
                            Other Major Projects
                        </h2>
                        <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
                            Our most coveted projects hand-picked by our editors
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-1 md:grid-rows-1 mx-5">
                        <ProjectList
                            data={props.listData.posts}
                            title="GO TO PROJECT"
                            path="/projects/"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Projects;
